import * as _ from "lodash";

import { ISODuration } from "../chart";
import { DataDescriptorEntity } from "./typings";
import { DefaultTimePeriod } from "./defaults";

/**
 * Resolve the ISO duration from the data descriptor
 * @param {DataDescriptorEntity} dataDescriptorEntity
 * @returns {ISODuration}
 */
const resolveISODuration = (dataDescriptorEntity: DataDescriptorEntity): ISODuration => {
  return _.get(dataDescriptorEntity, ["valueProperties", "defaultInterval"], DefaultTimePeriod);
};

export default {
  resolveISODuration
};
